import React from 'react'
import { Grid } from '@mui/material'
import { DateRangePicker } from 'rsuite';
import { Controller } from 'react-hook-form';
import { addDays, endOfWeek, startOfMonth, startOfWeek, subDays } from 'rsuite/esm/internals/utils/date';
import Image from './Image';
import Images from 'assets/images';
import "./InputDateRange.css";

const CalendarIcon = () => {
  return <Image src={Images.icon.calendar} />;
};

const InputDateRange = ({ xs, name, control, label, disabled, rules = {}, required, format = "dd/MM/yyyy" }) => {
  return (
    <>
      <Grid
        item
        xs={xs}
        alignContent="center"
        justifyContent={"center"}
        style={{ width: '100%' }}
      >
        <Controller
          name={name}
          control={control}
          rules={!disabled && {
            ...rules,
            required
          }}
          render={({
            field: { value, onChange },
            fieldState: { error },
          }) => (
            <>
              <DateRangePicker
                value={value}
                onChange={onChange}
                disabled={disabled}
                format={format}
                placeholder={label}
                style={{ 
                  width: '100%', 
                  border: '1px solid #041C3F',
                  borderRadius: '8px',
                }}
                cleanable={false}
                caretAs={CalendarIcon}
                ranges={[
                  {
                    label: 'Hoy',
                    value: [new Date(), new Date()],
                    placement: 'left'
                  },
                  {
                    label: 'Ayer',
                    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
                    placement: 'left'
                  },
                  {
                    label: 'Anteayer',
                    value: [addDays(new Date(), -2), addDays(new Date(), -2)],
                    placement: 'left'
                  },
                  {
                    label: 'Esta semana',
                    value: [startOfWeek(new Date()), endOfWeek(new Date())],
                    placement: 'left'
                  },
                  {
                    label: 'Este mes',
                    value: [startOfMonth(new Date()), new Date()],
                    placement: 'left'
                  },
                  {
                    label: 'Últimos 7 días',
                    value: [subDays(new Date(), 6), new Date()],
                    placement: 'left'
                  },
                  {
                    label: 'Últimos 30 días',
                    value: [subDays(new Date(), 29), new Date()],
                    placement: 'left'
                  },
                  {
                    label: 'Últimos 60 días',
                    value: [subDays(new Date(), 59), new Date()],
                    placement: 'left'
                  },
                ]}
              />
            </>
          )}
        />
      </Grid>
    </>
  )
}

export default InputDateRange